import React, { useState } from 'react';
import Modal from '@components/Modal';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { EventBus as eventBus } from "@components/EventBus";
import { showGlobalLoading, hideGlobalLoading } from "@services/axiosInstance";
import ClipLoader from "react-spinners/ClipLoader";

const DocumentPrintModal = ({ 
  modalId = "document-print",
  onPrint,
  isSubmitting = false,
  customTitle = "Imprimir Documento",
  showPageTypes = true,
  showPageSizes = true,
  defaultPageSize = 'a4',
  defaultPageType = '1',
  children 
}) => {
  const [selectedPageSize, setSelectedPageSize] = useState(defaultPageSize);
  const [selectedPageType, setSelectedPageType] = useState(defaultPageType);

  const handlePrintClick = async () => {
    showGlobalLoading('A preparar impressão...');
    eventBus.$emit(`Modal-${modalId}`, { isOpen: false });
    
    try {
      await onPrint({
        selectedPageSize,
        selectedPageType
      });
    } catch (error) {
      console.error('Erro ao imprimir:', error);
      hideGlobalLoading();
    }
  };

  return (
    <Modal id={modalId} modifier="very-small">
        <div className="select-page-to-print-modal">
          {children && children({ selectedPageSize, selectedPageType })}
          
          {showPageTypes && (
            <div className="form-group" style={{ marginBottom: '20px', marginTop: '20px', marginLeft: '22px' }}>
              <h2>Tipo de Página</h2>
              <RadioGroup
                column
                value={selectedPageType}
                onChange={(event) => setSelectedPageType(event.target.value)}
              >
                <FormControlLabel 
                  value="1" 
                  control={<Radio size="medium" />} 
                  style={{ 
                    border: '3px solid ' + (selectedPageType === '1' ? '#1A76D2' : '#E0E0E0'), 
                    borderRadius: '20px', 
                    padding: '10px' 
                  }} 
                  label={
                    <div className="page-item">
                      <span className="main">Original</span>
                    </div>
                  } 
                />
                <FormControlLabel 
                  value="2" 
                  control={<Radio size="medium" />} 
                  style={{ 
                    border: '3px solid ' + (selectedPageType === '2' ? '#1A76D2' : '#E0E0E0'), 
                    borderRadius: '20px', 
                    padding: '10px' 
                  }} 
                  label={
                    <div className="page-item">
                      <span className="main">Duplicado</span>
                    </div>
                  } 
                />
              </RadioGroup>
            </div>
          )}

          {showPageSizes && (
            <div className="form-group" style={{ marginBottom: '20px', marginTop: '20px', marginLeft: '22px' }}>
              <h2>Tamanho de Impressão</h2>
              <RadioGroup
                column
                value={selectedPageSize}
                onChange={(event) => setSelectedPageSize(event.target.value)}
              >
                <FormControlLabel 
                  value="a4" 
                  control={<Radio size="medium" />} 
                  style={{ 
                    border: '3px solid ' + (selectedPageSize === 'a4' ? '#1A76D2' : '#E0E0E0'), 
                    borderRadius: '20px', 
                    padding: '10px' 
                  }} 
                  label={
                    <div className="page-item">
                      <span className="main">A4</span>
                      <span className="secondary">Documento padrão</span>
                    </div>
                  } 
                />
                <FormControlLabel 
                  value="80mm" 
                  control={<Radio size="medium" />} 
                  style={{ 
                    border: '3px solid ' + (selectedPageSize === '80mm' ? '#1A76D2' : '#E0E0E0'), 
                    borderRadius: '20px', 
                    padding: '10px' 
                  }} 
                  label={
                    <div className="page-item">
                      <span className="main">80mm</span>
                      <span className="secondary">Impressoras POS/Recibos</span>
                    </div>
                  } 
                />
              </RadioGroup>
            </div>
          )}

          <button 
            className="btn btn-block btn-view-pdf" 
            onClick={handlePrintClick}
            disabled={isSubmitting}
          >
            {isSubmitting ? <ClipLoader size={20} /> : 'Avançar'}
          </button>
        </div>
      </Modal>
  );
};

export default DocumentPrintModal;
